import Header from './components/Header';
import Hero from './components/Hero';
import Rankings from './components/Rankings';
import Reviews from './components/Reviews';
import Compare from './components/Compare';
import Gossip from './components/Gossip';
import Tips from './components/Tips';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Rankings />
        <Reviews />
        <Compare />
        <Gossip />
        <Tips />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}